import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from './axiosInstance';

const useAxiosInterceptor = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // регистрируем перехватчик
        const id = axiosInstance.interceptors.response.use(
            response => response,
            error => {
                const status         = error.response?.status;
                const backendMessage = error.response?.data?.message || 'Неизвестная ошибка';
                const time           = error.response?.data?.timestamp;

                /* ===== 500 ===== */
                if (status === 500) {
                    navigate('/error', {
                        state: { code: 500, backendMessage, time },
                    });
                    return Promise.reject(error);
                }

                /* ===== всё остальное ===== */
                return Promise.reject(error);
            }
        );

        // снимаем перехватчик при размонтировании
        return () => axiosInstance.interceptors.response.eject(id);
    }, [navigate]);
};

export default useAxiosInterceptor;
